import {doHttpRequest} from "../util/NetUtil";

export const net_sendFeedback = (payload, handler, errorHandler) => {

    doHttpRequest("/feedback/create", payload, handler, errorHandler);
}